export enum EditablePostClientStatus {
    New,
    Updated,
    Deleted
}